import request from '@/utils/request'

export function list() {
  return request({
    url: '/client/nav/friendship/list',
    method: 'get'
  })
}
